import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NProductPlpTrustpilotReviewsConfig } from './product-plp-trustpilot-reviews.config.namespace';

ICmsContentService.registerConfig({
    id: NProductPlpTrustpilotReviewsConfig.ID,
    name: 'Product PLP Trustpilot Reviews',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'enabled',
            type: NICmsContentField.EFieldType.toggle,
            title: '',
            labels: {
                true: 'Enabled',
                false: 'Disabled'
            },
            default: true,
            description:
                'All of the fields below are passed directly to the Trustpilot widget. For the widget to work correctly, these values must match exactly the configuration set up on the Trustpilot website. After changing any of these fields, a page refresh is required to reload the widget.'
        },
        {
            key: 'templateId',
            type: NICmsContentField.EFieldType.text,
            title: 'Template ID'
        },
        {
            key: 'businessunitId',
            type: NICmsContentField.EFieldType.text,
            title: 'Business Unit ID'
        },
        {
            key: 'starColor',
            type: NICmsContentField.EFieldType.text,
            title: 'Star Color',
            default: '#fdb714'
        },
        {
            key: 'theme',
            type: NICmsContentField.EFieldType.text,
            title: 'Theme',
            default: 'light'
        }
    ]
});
